import { FC } from 'react'
import { planPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/types/enum'

const WhatsAppPrice: FC = () => {
  return (
    <>
      <div className='text-danger fw-semibold' style={{ fontSize: '16px' }}>
        <s>£5.99/month</s>
      </div>
      <div className='d-flex align-items-end'>
        <span
          className='fw-bold'
          style={{ fontSize: '32px', lineHeight: '1.2' }}
        >
          {planPrice.monthly[PlanSlug.WHATSAPP]}
        </span>
        <span
          className='text-muted fw-semibold mb-1'
          style={{ fontSize: '16px' }}
        >
          /month
        </span>
      </div>
    </>
  )
}

export default WhatsAppPrice
